const state= {
    Items:{
        data:[],
        total:0,
    },
};

const getters = {
    Items : (state) => state.Items,
};

const actions = {
    //Items
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/audit-trail`, {params:params})
                .then(response => {
                    commit('setItems', response.data.data);
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async exportAuditTrailUserInfo({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/audit-trail/export-user-info`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getAuditTrailUserInfo({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/audit-trail/user-info`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },

    // User Activity Logs
    async getUserActivityLogs({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/audit-trail/user-activity-logs`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async exportUserActivityLogs({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/audit-trail/export-user-activity-logs`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}